// eslint-disable-next-line no-magic-numbers
export function debounce<T extends (...args: any[]) => any>(fn: T, delay = 300): T {
  let prevTimer: any
  const res = (...args: any[]) => {
    if (prevTimer) {
      clearTimeout(prevTimer)
    }
    prevTimer = setTimeout(() => {
      fn(...args)
      prevTimer = null
    }, delay)
  }
  return res as any
}
